/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PersonalizationInputs */

const en_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalization`)
};

const ar_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخصيص`)
};

const bn_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পার্সোনালাইজেশন`)
};

const de_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalisierung`)
};

const es_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalización`)
};

const fr_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisation`)
};

const pt_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalização`)
};

const zh_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个性化`)
};

const tr_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kişiselleştirme`)
};

const ru_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Персонализация`)
};

const pl_svchip_personalization = /** @type {(inputs: Svchip_PersonalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizacja`)
};

/**
* | output |
* | --- |
* | "Personalization" |
*
* @param {Svchip_PersonalizationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_personalization = /** @type {((inputs?: Svchip_PersonalizationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PersonalizationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_personalization(inputs)
	if (locale === "bn") return bn_svchip_personalization(inputs)
	if (locale === "de") return de_svchip_personalization(inputs)
	if (locale === "es") return es_svchip_personalization(inputs)
	if (locale === "fr") return fr_svchip_personalization(inputs)
	if (locale === "pt") return pt_svchip_personalization(inputs)
	if (locale === "zh") return zh_svchip_personalization(inputs)
	if (locale === "tr") return tr_svchip_personalization(inputs)
	if (locale === "ru") return ru_svchip_personalization(inputs)
	if (locale === "pl") return pl_svchip_personalization(inputs)
	return en_svchip_personalization(inputs)
});